module.exports = __webpack_public_path__ + "img/image4.8c2706ec.png";